import { jsx as s, jsxs as E } from "react/jsx-runtime";
import c from "clsx";
import { C as O, u as R, s as U, T as q, v as K, w as X, O as J, G as Q, i as Y, a4 as Z, p as b, L as F, j as T, k as C, S as M } from "./helpers-458d7e27.js";
import { a as k } from "./TextGroup-dd19925e.js";
import "react";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
const u = "SwatchItem", o = new O(u), tt = {
  motionFeel: "Expressive",
  motionIntensity: "md",
  motionTypePreset: "moveUp",
  scrollTriggerOptions: {
    triggerOnce: !0
  }
}, d = ({
  className: a,
  headline: n,
  headlineTag: g = "span",
  rowStart: m = T.auto,
  rowSpan: i = 1,
  columnStart: p = C.inner2,
  columnSpan: l = 10,
  textPosition: N = "Bottom",
  theme: h = "blue 500",
  backgroundImageMediaFrame: e,
  link: t,
  analyticsCompName: r = u
}) => {
  const { viewportType: S } = R(), {
    environment: { host: f = "", pageSegment: G = "" } = {},
    requestor: { locality: { country: P = "" } = {} } = {}
  } = U(), L = !!(e != null && e.baseImage), x = ["xs", "sm", "md", "lg"].includes(S), _ = x ? "Large" : "Extra Large", A = x ? "Headline 6" : "Headline 5", H = q.getThemeClassName(h), B = K(
    {
      componentName: r,
      linkText: n,
      linkType: J.Tertiary,
      clickEvent: t == null ? void 0 : t.clickEventName,
      ariaLabel: t == null ? void 0 : t.ariaLabel,
      serverFptiData: t == null ? void 0 : t.serverFptiData
    },
    G,
    X.CTA
  ), I = c(
    o.getComponentClassName(),
    a,
    H,
    "arrow-icon-active-hover"
  ), V = c(
    o.getElementClassName("container"),
    o.getPropsValueClassName("textposition", N),
    a
  ), $ = c(
    o.getElementClassName("bgackgroundimg"),
    a
  ), j = c(
    o.getElementClassName("textArrowSection"),
    o.getPropsValueClassName("textPosition", N)
  ), z = (v) => v === C.inner2 ? C.inner1 : C.inner3, D = (v) => v === 10 ? 4 : 2, W = {
    options: {
      rowStart: T.auto,
      rowSpan: i,
      columnStart: T.leftInner,
      columnSpan: 4
    },
    mdOptions: {
      rowStart: m,
      rowSpan: i,
      columnStart: z(p),
      columnSpan: D(l)
    },
    lgOptions: {
      rowStart: m,
      rowSpan: i,
      columnStart: p,
      columnSpan: l
    }
  };
  return /* @__PURE__ */ s(Q, { ...W, children: /* @__PURE__ */ E(
    Y,
    {
      as: "a",
      motionOptions: tt,
      target: t == null ? void 0 : t.target,
      className: I,
      href: Z((t == null ? void 0 : t.url) || "", f, P),
      "data-pa-click": r && B,
      whileHover: {
        scale: 1.01,
        "--background-scale": "1.02"
      },
      children: [
        L && /* @__PURE__ */ s(
          b,
          {
            type: "Image",
            image: {
              baseImage: e == null ? void 0 : e.baseImage,
              imageAltText: e == null ? void 0 : e.imageAltText,
              dimensions: {
                minHeight: "100%",
                minWidth: "100%"
              }
            },
            maxSrcSetWidth: 1500,
            motionOptions: {
              motionTypePreset: "appear",
              motionIntensity: "lg"
            },
            className: $,
            ariaHidden: !0,
            analyticsCompName: r
          }
        ),
        /* @__PURE__ */ s("div", { className: V, children: /* @__PURE__ */ E("div", { className: j, children: [
          /* @__PURE__ */ s("div", { className: o.getElementClassName("text-section"), children: n && /* @__PURE__ */ s(
            k,
            {
              headlineTag: g,
              headline: n,
              headlineSize: A,
              analyticsCompName: r
            }
          ) }),
          t && /* @__PURE__ */ s(
            "div",
            {
              className: o.getElementClassName("arrow-section"),
              children: /* @__PURE__ */ s(F, { ...t, size: _ })
            }
          )
        ] }) })
      ]
    }
  ) });
};
d.displayName = u;
const w = "SwatchGridType", y = new O(w), et = ({
  className: a = "",
  collection: n = [],
  topSpacer: g = "4vw",
  bottomSpacer: m = "4vw",
  theme: i,
  disclosureType: p,
  componentId: l,
  ...N
}) => {
  const h = c(
    y.getElementClassName("sectionContainer"),
    y.getPropsValueClassName("length", `${n.length}`),
    a
  );
  return /* @__PURE__ */ s(
    M,
    {
      className: h,
      options: { topSpacing: g, bottomSpacing: m },
      theme: i,
      disclosure: p,
      id: l,
      ...N,
      children: n.map((t, r) => {
        const S = `grid-item-${r}`;
        return /* @__PURE__ */ s(
          d,
          {
            ...t,
            analyticsCompName: w
          },
          S
        );
      })
    }
  );
};
et.displayName = w;
export {
  et as default
};
//# sourceMappingURL=SwatchGridType.js.map
